import { Component, EventEmitter, OnInit, Output, computed, input, model } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { PlatformType } from "@root/config";
import { PriceChild } from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";
import { SharedModule } from "@root/shared/shared.module";

interface HouseItem {
  house_info: PriceChild;
  payment_type: number;
  [props: string]: any;
}

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "host-copy-price-form-item",
  templateUrl: "./copy-price-form-item.component.html",
  styleUrls: ["./copy-price-form-item.component.scss"],
})
export class CopyPriceFormItemComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;
  @Output() onCheckChange = new EventEmitter<boolean>();
  data = model<HouseItem>();
  active = input(false);
  disabled = input(false);

  entity = computed<PriceChild>(() => {
    return this.data()?.house_info;
  });

  // options = computed<Option[]>(() => {

  // });

  constructor() {
    toObservable(this.disabled).subscribe((value) => {
      if (value) {
        this.data.update((v) => ({
          ...v,
          checked: false,
        }));
        this.onCheckChange.emit(false);
      }
    });
  }

  ngOnInit() {}

  // onCheckChange(checked) {

  // }
}
